import { AppBar, Toolbar, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
    getSharedNavAppBarSx,
    QR_FLEX_WORDMARK_SX,
    sharedNavToolbarSx,
} from "./navTheme";

export default function SubTopHeader() {
    const navigate = useNavigate();

    return (
        <AppBar elevation={0} sx={getSharedNavAppBarSx()}>
            <Toolbar sx={{ ...sharedNavToolbarSx, justifyContent: "center" }}>
                <Typography
                    component="button"
                    type="button"
                    onClick={() => navigate("/")}
                    sx={{
                        ...QR_FLEX_WORDMARK_SX,
                        border: 0,
                        p: 0,
                        backgroundColor: "transparent",
                        cursor: "pointer",
                        fontSize: { xs: "1.22rem", md: "1.38rem" },
                    }}
                >
                    QR Flex
                </Typography>
            </Toolbar>
        </AppBar>
    );
}
